import React, { useState, useRef } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import "./App.css";

import HomeScreen from "./components/HomeScreen";
import QuizPage from "./components/QuizPage";
import ResultPage from "./components/ResultPage";
import AudioModal from "./components/AudioModal";
import Dashboard from "./components/Dashboard";
import SubjectPage from "./components/SubjectPage";
import Question from "./components/Question";
import Register from "./components/Register";

export default function App() {
  const [showResult, setShowResult] = useState(false);

  const [userAnswers, setUserAnswers] = useState([]);

  const [showAudioModal, setShowAudioModal] = useState(false);

  // Can now contain either:
  //
  // {
  //   type: "audio",
  //   url: "..."
  // }
  //
  // OR
  //
  // {
  //   type: "image",
  //   url: "..."
  // }

  const [currentAudioUrl, setCurrentAudioUrl] = useState(null);

  const [testno, setTestno] = useState("");

  const [inputTestno, setInputTestno] = useState("");

  const navigate = useNavigate();

  const timerRef = useRef(null);

  // Restart quiz completely
  const restartQuiz = () => {
    setUserAnswers([]);

    setShowResult(false);

    setShowAudioModal(false);

    setCurrentAudioUrl(null);

    setTestno("");

    setInputTestno("");

    navigate("/dashboard");
  };

  // Open explanation modal
  const openAudioModal = (content) => {
    if (content && content.url) {
      setCurrentAudioUrl(content);

      setShowAudioModal(true);
    }
  };

  const closeAudioModal = () => {
    setShowAudioModal(false);

    setCurrentAudioUrl(null);
  };

  // Handle start from Dashboard
  const handleStart = () => {
    if (inputTestno.trim()) {
      setTestno(inputTestno.trim());

      navigate("/test");
    }
  };

  return (
    <div className="app">
      <Routes>
        {/* Home Screen */}

        <Route path="/" element={<HomeScreen />} />

        {/* Dashboard */}

        <Route
          path="/dashboard"
          element={
            <Dashboard
              inputTestno={inputTestno}
              setInputTestno={setInputTestno}
              handleStart={handleStart}
            />
          }
        />

        {/* Subject Page */}

        <Route
          path="/subject/:subject"
          element={<SubjectPage setTestno={setTestno} />}
        />

        {/* Question Upload Page */}

        <Route path="/question" element={<Question />} />
        <Route path="/register" element={<Register />} />

        {/* Quiz Route */}

        <Route
          path="/test"
          element={
            !showResult ? (
              <QuizPage
                testno={testno}
                onQuizComplete={(answers) => {
                  setUserAnswers(answers);

                  setShowResult(true);
                }}
                onOpenAudio={openAudioModal}
              />
            ) : (
              <ResultPage
                userAnswers={userAnswers}
                onRestart={restartQuiz}
                onOpenAudio={openAudioModal}
              />
            )
          }
        />
      </Routes>

      {/* Global Explanation Modal */}

      <AudioModal
        showAudioModal={showAudioModal}
        currentAudioUrl={currentAudioUrl}
        onClose={closeAudioModal}
        userAnswers={userAnswers}
      />
    </div>
  );
}
